import { render, staticRenderFns } from "./Lab-select-orders.vue?vue&type=template&id=f67a0df6&scoped=true"
import script from "./Lab-select-orders.js?vue&type=script&lang=js&external"
export * from "./Lab-select-orders.js?vue&type=script&lang=js&external"
import style0 from "./Lab-select-orders.vue?vue&type=style&index=0&id=f67a0df6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f67a0df6",
  null
  
)

export default component.exports